import { buildManufacturingTypePayloadForStlPart, isStlFile, STL_MANUFACTURING_TYPE } from '@partsbadger/utils';
import { QuoteLineItemProps } from '@partsbadger/types';

export { STL_MANUFACTURING_TYPE, buildManufacturingTypePayloadForStlPart };

export const STL_PROCESS_LOCKED_MESSAGE = 'STL files are only supported for 3D Printing.';

export const STL_PROCESS_LOCKED_DESCRIPTION =
    'For CNC, sheet metal, or other processes, upload a STEP, STP, or IGES file instead.';

export const getPart3dFilename = (part?: QuoteLineItemProps | null): string | undefined => {
    return part?.product?.attachments?.file3d?.filename ?? undefined;
};

export const isStlPart = (part?: QuoteLineItemProps | null): boolean => {
    return isStlFile(getPart3dFilename(part));
};
